import BusinessHours from './BusinessHours'
import { returnHoursInDays } from './help/index'
import { THoursInDay } from 'types/openHour'

export default BusinessHours
export { returnHoursInDays }
export type { THoursInDay }
